<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Cấu hình hệ thống</div>
      </div>
      <div class="box-tabview">
        <TabView @tab-change="clickChange">
          <TabPanel :key="'0'"   header="Cấu hình chung" v-if="checkVisible('config', 'all')">
            <System v-if="activeIndex == 0" />
          </TabPanel>
          <TabPanel :key="'1'" header="Nhóm sản phẩm" v-if="checkVisible('categories', 'all')">
            <Categories v-if="activeIndex == 1"/>
          </TabPanel>
          <TabPanel :key="'2'" header="Loại đơn vị" v-if="checkVisible('setting_unit', 'all')">
            <SettingUnit  v-if="activeIndex == 2" />
          </TabPanel>
          <TabPanel :key="'3'" header="Danh sách lý do" v-if="checkVisible('setting_reason_reject', 'all')">
            <SettingReasonReject v-if="activeIndex == 3"/>
          </TabPanel>
          <TabPanel :key="'4'" header="Cấu hình dynamic form" v-if="checkVisible('dynamic_form', 'all')">
            <DynamicForm v-if="activeIndex == 4"/>
          </TabPanel>
          <TabPanel :key="'5'" header="Loại sự cố" v-if="checkVisible('type_violation', 'all')">
            <TypeViolation v-if="activeIndex == 5"/>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </div>
</template>

<script>
import Categories from './categories';
import SettingUnit from './setting_unit';
import SettingReasonReject from './setting_reason_reject';
import DynamicForm from './dynamic_form';
import System from './system';
import TypeViolation from './type_violation';
export default {
  components: {
    Categories,
    SettingUnit,
    SettingReasonReject,
    System,
    DynamicForm,
    TypeViolation
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  mounted () {
    this.initParams();
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    initParams() {
      if (this.$store.getters.fullname.user_type == 2) {
        setTimeout(() => {
          if(this.checkVisible('config', 'all')) this.activeIndex = 0;
          else if(this.checkVisible('categories', 'all')) this.activeIndex = 1;
          else if(this.checkVisible('setting_unit', 'all')) this.activeIndex = 2;
          else if(this.checkVisible('setting_reason_reject', 'all')) this.activeIndex = 3;
          else if(this.checkVisible('dynamic_form', 'all')) this.activeIndex = 4;
          else if(this.checkVisible('type_violation', 'all')) this.activeIndex = 5;
        }, 1000);
      }
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    clickChange($event) {
      if ($event != undefined) this.activeIndex = parseInt($event.tab.$vnode.data.key);
    }
  }
}
</script>
<style lang="scss">
.box-tabview{
  .p-tabview-nav{
    li{margin-right: 0;
      a{border-radius: 0 !important; font-weight: normal !important; text-decoration: none;}
      &.p-highlight{
        .p-tabview-nav-link{background: #ffff; border: 1px solid #c8c8c8; color: #007ad9 !important;}
      }
    }
    li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link{background: #f4f4f4;border: 1px solid #c8c8c8;}
  }
  .p-tabview-panels{padding: 30px;}
  // .label-header-action{display: block;}
}
</style>